import { Container } from 'components/ui'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import useProductsContext from '../services/productsContext'
import { imgUrl } from 'utils/imgUrl'

const CategoryHeader = () => {
  const { t } = useTranslation()
  const { i18n } = useTranslation()
  const language = useMemo(
    () => i18n.language as 'uz' | 'ru' | 'en',
    [i18n.language]
  )
  const {
    state: { category, data }
  } = useProductsContext()
  return (
    <div
      className="category-header"
      style={{
        backgroundImage: `url(${imgUrl(category?.image)})`
      }}
    >
      <Container size="xxl" style={{ textAlign: 'center' }}>
        <h1 className="cormorant-title">{category?.name[language]}</h1>
        <p>
          {data?.length || 0} {t('categories.available_products')}
        </p>
      </Container>
    </div>
  )
}

export default CategoryHeader
